'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002411 from "./presto.-Agent-View$$anon$11.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dError$0024 from "./presto.-Agent-View$-Error$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$10() {
  this.avL = null;
  this.avD = null;
  this.avE = false;
  this.avM = null;
  this.avN = false;
  this.avQ = null;
  this.avJ = null;
  this.avK = false;
  this.avF = null;
  this.avG = false;
  this.avH = null;
  this.avI = false;
  this.avO = false;
  this.avP = false;
  this.avL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.avQ = "Error";
}
export { $c_Lpresto_AgentView$$anon$10 as $c_Lpresto_AgentView$$anon$10 };
$p = $c_Lpresto_AgentView$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$10;
/** @constructor */
function $h_Lpresto_AgentView$$anon$10() {
}
export { $h_Lpresto_AgentView$$anon$10 as $h_Lpresto_AgentView$$anon$10 };
$h_Lpresto_AgentView$$anon$10.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.avL;
});
$p.L = (function() {
  if ((!this.avE)) {
    this.avD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.avE = true;
  }
  return this.avD;
});
$p.O = (function() {
  if ((!this.avN)) {
    this.avM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.avN = true;
  }
  return this.avM;
});
$p.E = (function() {
  return this.avQ;
});
$p.t = (function() {
  if ((!this.avK)) {
    this.avJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avK = true;
  }
  return this.avJ;
});
$p.M = (function() {
  if ((!this.avG)) {
    this.avF = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.avG = true;
  }
  return this.avF;
});
$p.Q = (function() {
  if ((!this.avI)) {
    this.avH = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002411.$c_Lpresto_AgentView$$anon$11();
    this.avI = true;
  }
  return this.avH;
});
$p.w = (function() {
  if ((!this.avP)) {
    this.avO = false;
    this.avP = true;
  }
  return this.avO;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee71) => ((p) => \u03b4scrutinee71))($j_presto$002e$002dAgent$002dView$0024$002dError$0024.$m_Lpresto_AgentView$Error$())));
});
var $d_Lpresto_AgentView$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$10, "presto.AgentView$$anon$10", ({
  Dy: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$10 as $d_Lpresto_AgentView$$anon$10 };
//# sourceMappingURL=presto.-Agent-View$$anon$10.js.map
